import { createSlice } from "@reduxjs/toolkit";
import { getNotificationAPI } from "../../api/notification";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getNotificationSlice = createSlice({
  name: "getNotification",
  initialState: data,
  reducers: {
   getNotificationSlice(state) {
      state.isLoading = true;
    },
   getNotificationSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getNotificationSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getNotificationSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getNotificationHandler: any = (page:any,limit:any) => async (dispatch: any) => {
  try {
    dispatch(getNotificationAction.getNotificationSlice());
    const response: any = await getNotificationAPI(page,limit);
    
    dispatch(getNotificationAction.getNotificationSliceSuccess(response));
  } catch (e: any) {
    dispatch(getNotificationAction.getNotificationSliceFailure(e?.response?.data));
  }
};
export default getNotificationSlice.reducer;
export const getNotificationAction = getNotificationSlice.actions;
